// extracted by mini-css-extract-plugin
module.exports = {"left":"style_left__7mjek","right":"style_right__jgPQW"};